import { ApiServiceProps } from "DataTypes/Services/Index.type";
import { post } from ".";

const PatientDetailsUpdate: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: `patient/${payload.id1}/update`,
    data: { data: payload.data },
    isRedox: true,
  };
  return post(request);
}

const CategorySearch: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: `patient/${payload.id1}/category/search`,
    data: { data: payload.data },
    isRedox: true,
    dedupe: true,
  };
  return post(request);
};

const DocDownload: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: `patient/${payload.id1}/document/download`,
    data: { data: payload.data },
    isRedox: true,
    excel: true,
  };
  return post(request);
};

const DocIndex: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: `patient/${payload.id1}/index/create`,
    isRedox: true,
  };
  return post(request);
};

const AllergySearch: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: `patient/${payload.id1}/allergies/search`,
    isRedox: true,
    data: { data: payload.data }
  };
  return post(request);
};

const AddUpdateAllergies: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: "patient/allergies/update",
    data: { data: payload.data },
    isRedox: true,
  };
  return post(request);
};

const DeleteAllergies: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: `patient/allergies/${payload.id1}/delete`,
    isRedox: true,
  };
  return post(request);
};

const ProblemSearch: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: `patient/${payload.id1}/problem/search`,
    isRedox: true,
    data: { data: payload.data }
  };
  return post(request);
};

const AddUpdateProblem: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: "patient/problem/update",
    data: { data: payload.data },
    isRedox: true,
  };
  return post(request);
};

const DeleteProblem: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: `patient/problem/${payload.id1}/delete`,
    isRedox: true,
  };
  return post(request);
};

const ProblemAltCodeSearch: (data: ApiServiceProps) => any = (data) => {
  const request = {
    subUrl: `patient/${data.id1}/alt-code/search`,
    isRedox: true,
    data: { data: {} },
  };
  return post(request);
};

const CodeSearch: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: `patient/${payload.id1}/code-exist?code=${payload.data}`,
    isRedox: true,
  };
  return post(request);
};

const MedSearch: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: `patient/${payload.id1}/medication/search`,
    data: { data: payload.data },
    isRedox: true,
  };
  return post(request);
};

const AddUpdateMeds: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: "patient/medication/create/update",
    data: { data: payload.data },
    isRedox: true,
  };
  return post(request);
};

const AddPatient: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: "patient/add",
    data: { data: payload.data },
    isRedox: true,
  };
  return post(request);
};

const DeleteMeds: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: `patient/medication/${payload.id1}/delete`,
    isRedox: true,
  };
  return post(request);
};

const VisitSearch: (data: ApiServiceProps) => any = (data) => {
  const request = {
    subUrl: `patient/${data.id1}/visit/search`,
    isRedox: true,
  };
  return post(request);
};

const VaccineSearch: (data: ApiServiceProps) => any = (data) => {
  const request = {
    subUrl: `patient/${data.id1}/immunization/search`,
    isRedox: true,
  };
  return post(request);
};

const AddUpdateVaccine: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: "patient/immunization/update",
    data: { data: payload.data },
    isRedox: true,
  };
  return post(request);
};

const DeleteVaccine: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: `patient/immunization/${payload.id1}/delete`,
    isRedox: true,
  };
  return post(request);
};

const ResultSearch: (data: ApiServiceProps) => any = (data) => {
  const request = {
    subUrl: `patient/${data.id1}/result/search`,
    isRedox: true,
  };
  return post(request);
};

const AddUpdateResult: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: "patient/result/create/update",
    data: { data: payload.data },
    isRedox: true,
  };
  return post(request);
};

const DeleteResult: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: `patient/result/${payload.id1}/delete`,
    isRedox: true,
  };
  return post(request);
};

const AddUpdateVital: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: "patient/vitalsign/create/update",
    data: { data: payload.data },
    isRedox: true,
  };
  return post(request);
};

const DeleteVital: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: `patient/vitalsign/${payload.id1}/delete`,
    isRedox: true,
  };
  return post(request);
};

export default {
  PatientDetailsUpdate,
  CategorySearch,
  DocDownload,
  DocIndex,
  MedSearch,
  AddUpdateMeds,
  AddPatient,
  DeleteMeds,
  VisitSearch,
  AllergySearch,
  AddUpdateAllergies,
  DeleteAllergies,
  ProblemSearch,
  AddUpdateProblem,
  CodeSearch,
  DeleteProblem,
  ProblemAltCodeSearch,
  VaccineSearch,
  AddUpdateVaccine,
  DeleteVaccine,
  ResultSearch,
  AddUpdateResult,
  DeleteResult,
  AddUpdateVital,
  DeleteVital
};
